import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
    const { locale, setLocale, locales } = useLang();
    return (
        <div
            className={`inline-flex items-center gap-1 rounded-full border border-current/20 px-1 py-0.5 ${className}`}
            data-testid="language-toggle"
            role="group"
            aria-label="Language"
        >
            <Globe size={12} className="opacity-60 ml-1.5" aria-hidden />
            {locales.map((l) => {
                const active = l.code === locale;
                return (
                    <button
                        key={l.code}
                        type="button"
                        onClick={() => setLocale(l.code)}
                        aria-pressed={active}
                        className={`px-2.5 py-0.5 rounded-full text-[0.6rem] tracking-[0.22em] uppercase font-semibold transition-colors ${
                            active
                                ? "bg-current/15 text-current"
                                : "text-current/60 hover:text-current"
                        }`}
                        data-testid={`language-option-${l.code}`}
                    >
                        {l.short}
                    </button>
                );
            })}
        </div>
    );
}
